/**
 * Normalized payment-processor result (Phase 4 payment strategy layer).
 *
 * Every processor (cash, NABancard, Dejavoo, Windcave, gift card) returns a
 * value of this exact shape so the checkout `pay()` orchestration can build the
 * stored payment object and drive post-processing without per-processor
 * branching. The processors are pure: they translate a raw device/helper
 * response into this shape and never touch Vuex, modals, or `this`.
 *
 * Fields:
 *   approved          {boolean} processor approved the charge → proceed to build
 *                     the payment object. `false` means the caller should abort
 *                     (and usually show `error`).
 *   processorResponse {string}  value stored on payment.processor_response.
 *                     Integrations carry the raw/serialized gateway response;
 *                     cash & gift card carry the legacy sentinel "no data".
 *   tips              {number|null} tip amount reported by the processor, or null
 *                     when the processor does not override the order's tips.
 *   cardLastFour      {string|null|undefined} last four of the card (integrations).
 *   cardMeta          {object} extra card / auth fields (Dejavoo partial flow).
 *   isPartialApproval {boolean} gateway approved less than requested.
 *   approvedAmount    {number|null} amount actually approved (partial flow).
 *   terminalFee       {number|null} terminal-applied surcharge (Dejavoo).
 *   error             {string|null} failure reason for the error modal.
 *   raw               {*} the original processor response, for callers that need
 *                     processor-specific fields not covered above.
 */
export function makePaymentResult(overrides = {}) {
  return {
    approved: false,
    processorResponse: "no data",
    tips: null,
    cardLastFour: null,
    cardMeta: {},
    isPartialApproval: false,
    approvedAmount: null,
    terminalFee: null,
    error: null,
    raw: null,
    ...overrides,
  };
}
